import { JsonObject } from '@bufbuild/protobuf';
import { Banner } from '@q6cyber/proto2es/generated/common';

import { FormControl, FormGroup, Validators } from '@angular/forms';

import { RouterOutput } from '../../../utils';
import { customFormGroup } from '../utilities';
import { isBannerUrlValidator } from '../validations';
import { CorruptedData } from './generic-data.interface';

export interface BannerListResponse
  extends
    Omit<RouterOutput['bannerManager']['list']['edges'][0], 'node'>,
    CorruptedData {
  node: Banner | null;
}

export const DEFAULT_BANNER_MANAGER = new Banner()
  .fromJson({
    active: true,
    severity: 'BANNER_SEVERITY_WHITE',
    align: 'BANNER_ALIGN_CENTER',
  })
  .toJson({
    emitDefaultValues: true,
  }) as JsonObject;

export type BannerManagerFormGroup = ReturnType<typeof bannerManagerForm>;

export const bannerManagerForm = () => {
  return customFormGroup(
    {
      id: new FormControl(''),
      message: new FormGroup({
        EN: new FormControl('', [
          Validators.required,
          Validators.maxLength(510),
        ]),
      }),
      link: new FormGroup({
        title: new FormGroup({
          EN: new FormControl('', Validators.maxLength(170)),
        }),
        url: new FormGroup({
          EN: new FormControl('', isBannerUrlValidator),
        }),
      }),
      active: new FormControl(true, { nonNullable: true }),
      severity: new FormControl<string | null>(null, Validators.required),
      align: new FormControl<string | null>(null, Validators.required),
      clients: new FormControl<string[]>([], { nonNullable: true }),
      entitlement: new FormControl<string[]>([], { nonNullable: true }),
      createdBy: new FormControl(''),
      expiration: new FormControl<string | null>(null, Validators.required),
    },
    {
      errorMessages: [
        {
          fieldKey: 'message.EN',
          errorName: 'required',
          message: 'Message is required',
        },
        {
          fieldKey: 'severity',
          errorName: 'required',
          message: 'Severity is required',
        },
        {
          fieldKey: 'align',
          errorName: 'required',
          message: 'Align is required',
        },
        {
          fieldKey: 'expiration',
          errorName: 'required',
          message: 'Expiration date is required',
        },
        {
          fieldKey: 'link.url.EN',
          errorName: 'invalidUrl',
          message: 'Link URL must be a valid URL or relative path',
        },
      ],
    }
  );
};
